import {
    createProcessPayroll,
    deletePayroll,
    getActivePayroll,
    getActiveProcessPayroll,
    getPayrollById,
    getProcessedPayroll,
    getProcessedPayrollBatches,
    resolvePayroll,
    unProcessPayroll,
} from './staffPayroll.action';
export { staffPayrollReducer } from './staffPayroll.reducer';
export { watchStaffPayroll } from './staffPayroll.saga';

export const staffPayrollActions = {
    /** Active Payroll */
    getActivePayroll,
    getActiveProcessPayroll,
    createProcessPayroll,
    getPayrollById,
    deletePayroll,
    resolvePayroll,
    /** End */

    /** Processed Payroll */
    getProcessedPayroll,
    getProcessedPayrollBatches,
    unProcessPayroll,
    /** End */
};
